import React, { useRef, useEffect } from "react";

export default function OtpInput({ length = 4, value, onChange, autoFocus = true, testIdPrefix = "otp" }) {
  const refs = useRef([]);

  useEffect(() => {
    if (autoFocus && refs.current[0]) refs.current[0].focus();
  }, [autoFocus]);

  const setDigit = (idx, d) => {
    const next = value.split("");
    while (next.length < length) next.push("");
    next[idx] = d;
    onChange(next.join("").slice(0, length));
  };

  const handleChange = (idx, e) => {
    const v = e.target.value.replace(/\D/g, "");
    if (!v) {
      setDigit(idx, "");
      return;
    }
    if (v.length > 1) {
      const chars = v.slice(0, length - idx).split("");
      const merged = (value || "").split("");
      while (merged.length < length) merged.push("");
      chars.forEach((c, i) => (merged[idx + i] = c));
      onChange(merged.join("").slice(0, length));
      const nextIdx = Math.min(idx + chars.length, length - 1);
      refs.current[nextIdx]?.focus();
      return;
    }
    setDigit(idx, v);
    if (idx < length - 1) refs.current[idx + 1]?.focus();
  };

  const handleKeyDown = (idx, e) => {
    if (e.key === "Backspace" && !value[idx] && idx > 0) {
      refs.current[idx - 1]?.focus();
    }
  };

  const digits = [];
  for (let i = 0; i < length; i++) digits.push(value[i] || "");

  return (
    <div className="flex gap-2 justify-center" data-testid="otp-input-group">
      {digits.map((d, i) => (
        <input
          key={i}
          ref={(el) => (refs.current[i] = el)}
          data-testid={`${testIdPrefix}-input-${i}`}
          inputMode="numeric"
          type="text"
          maxLength={i === 0 ? length : 1}
          value={d}
          onChange={(e) => handleChange(i, e)}
          onKeyDown={(e) => handleKeyDown(i, e)}
          className={`w-[52px] h-[60px] text-center text-[26px] font-bold font-display rounded-xl border bg-neutral-50 outline-none tabular-nums transition-all ${
            d
              ? "border-brand bg-white text-black shadow-[0_0_0_3px_rgba(255,90,0,0.10)]"
              : "border-neutral-200 text-neutral-400"
          } focus:border-brand focus:bg-white focus:text-black focus:shadow-[0_0_0_3px_rgba(255,90,0,0.15)]`}
        />
      ))}
    </div>
  );
}
